import { match as a_test } from "../../../src/params/a_test.ts";
import { match as b_test } from "../../../src/params/b_test.ts";
import { match as blog_cat } from "../../../src/params/blog_cat.ts";
import { match as cat } from "../../../src/params/cat.ts";
import { match as field_cat } from "../../../src/params/field_cat.ts";
import { match as sub } from "../../../src/params/sub.ts";

export const matchers = { a_test, b_test, blog_cat, cat, field_cat, sub };